import React from 'react';
import { _translate, translate } from '../../../utils/wp.js';
import { Dropdown } from '../../Dropdown';

export function RoomSelector({numberOfGuests, value, disabled, onChange}) {
    let persons = numberOfGuests;
    let reminder = persons % 2;
    let rooms = (persons - reminder) / 2;
    let triple = '';
    let single = '';

    if (rooms - 1 === 0) {
        single =
            `1 ${_translate('hotel_room_double_short')} + 1 ${_translate(
                'hotel_room_single_short')}`;
        triple = `1 ${_translate('hotel_room_triple_short')}`;
    } else {
        single =
            `${rooms} ${_translate('hotel_room_double_short')} + 1 ${_translate(
                'hotel_room_single_short')}`;
        triple =
            `${rooms -
            1} ${_translate('hotel_room_double_short')} + 1 ${_translate(
                'hotel_room_triple_short')}`;
    }

    if (persons === 1) {
        triple = `1 ${_translate('hotel_room_triple')}`;
        single = `1 ${_translate('hotel_room_single')}`;
    }

    return (
        <Dropdown
            label={`${translate('rooms')}: ${value === 0 ? single : triple}`}
            value={value}
            options={[
                {value: 0, label: single},
                persons > 2 && {value: 1, label: triple},
            ].filter(Boolean)}
            disabled={disabled}
            onChange={onChange}
        />
    );
}
